module.exports = __webpack_public_path__ + "static/media/img2.07c9b4fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/img2.jpg
// module id = 716
// module chunks = 0